import { useAuth } from '@berky/auth'
import {
  LoadingSkeleton,
  ModuleNavigation,
  ModuleNavigationGroup,
  ModuleNavigationItem,
  ModuleSidebarLayout,
} from '@berky/ui'
import { Navigate, NavLink, Outlet, useLocation } from 'react-router'

import { SettingsOverviewPage } from './settings-overview-page'
import { settingsSections } from './settings-sections'
import { roleAccess } from '../module-access'
import { PLATFORM_ADMIN_ROLE } from '../verwaltung/api'

export function SettingsLayout() {
  const { user, isLoading } = useAuth()
  const { pathname } = useLocation()
  const access = roleAccess(user?.roles, [PLATFORM_ADMIN_ROLE])

  if (isLoading || access === 'unbekannt') {
    return <LoadingSkeleton variant="text" rows={5} />
  }
  if (access !== 'erlaubt') {
    return <Navigate to="/forbidden" replace state={{ moduleTitle: 'Einstellungen' }} />
  }

  const isOverview = pathname.replace(/\/+$/, '') === '/einstellungen'

  return (
    <ModuleSidebarLayout
      title="Einstellungen"
      description="Plattformfunktionen und Berechtigungen verwalten."
      navigation={
        <ModuleNavigation aria-label="Einstellungen">
          <ModuleNavigationGroup
            label="Einstellungen"
            headingLink={
              <NavLink to="/einstellungen" end>
                Einstellungen
              </NavLink>
            }
            headingLinkActive={isOverview}
          >
            {settingsSections.map(({ path, title, Icon }) => (
              <ModuleNavigationItem
                key={path}
                asChild
                kind="route"
                active={pathname === path}
                icon={<Icon className="size-4" />}
              >
                <NavLink to={path} end>
                  {title}
                </NavLink>
              </ModuleNavigationItem>
            ))}
          </ModuleNavigationGroup>
        </ModuleNavigation>
      }
    >
      {isOverview ? <SettingsOverviewPage /> : <Outlet />}
    </ModuleSidebarLayout>
  )
}
